<template>
  <div :class="rateStatus">
    <div class="rating">
      <template v-for="rate in rateValues">
        <input @click="selectedRate(rate)" type="radio" :checked="selectedValue==rate"
               class="active-input"
               name="rating"
               :id="`rating-${rate}-${generator}`">
        <label class="active-label" :for="`rating-${rate}-${generator}`"></label>
      </template>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default defineComponent({
  name: "Rate1",
  props: {
    commentRate: {
      default: 0,
    }
  },
  data() {
    return {
      rateValues: [5, 4, 3, 2, 1],
      selectedValue: 0
    }
  },
  computed: {
    rateStatus() {
      return this.commentRate > 0 ? 'feedback touch-none' : 'feedback'
    },
    generator(){
      return generateHash()
    }
  },
  methods: {
    selectedRate(value) {
      if (this.commentRate == 0) {
        this.selectedValue = value
        this.$emit('update:modelValue', this.selectedValue)
      }
    }
  },
  mounted() {
    this.selectedValue = this.commentRate
  }
})
</script>

<style scoped>
.rating {
  display: flex;
  width: 90%;
  justify-content: flex-end;
  overflow: hidden;
  flex-direction: row-reverse;
  height: auto;
  position: relative;
}

.rating > .active-input {
  display: none;
}

.rating > label {
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-top: auto;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='126.729' height='126.73'%3e%3cpath fill='%23e3e3e3' d='M121.215 44.212l-34.899-3.3c-2.2-.2-4.101-1.6-5-3.7l-12.5-30.3c-2-5-9.101-5-11.101 0l-12.4 30.3c-.8 2.1-2.8 3.5-5 3.7l-34.9 3.3c-5.2.5-7.3 7-3.4 10.5l26.3 23.1c1.7 1.5 2.4 3.7 1.9 5.9l-7.9 32.399c-1.2 5.101 4.3 9.3 8.9 6.601l29.1-17.101c1.9-1.1 4.2-1.1 6.1 0l29.101 17.101c4.6 2.699 10.1-1.4 8.899-6.601l-7.8-32.399c-.5-2.2.2-4.4 1.9-5.9l26.3-23.1c3.8-3.5 1.6-10-3.6-10.5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 76%;
  transition: .3s;
}

.rating > .active-input:checked ~ label,
.rating > .active-input:checked ~ label ~ label {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='126.729' height='126.73'%3e%3cpath fill='%23fcd93a' d='M121.215 44.212l-34.899-3.3c-2.2-.2-4.101-1.6-5-3.7l-12.5-30.3c-2-5-9.101-5-11.101 0l-12.4 30.3c-.8 2.1-2.8 3.5-5 3.7l-34.9 3.3c-5.2.5-7.3 7-3.4 10.5l26.3 23.1c1.7 1.5 2.4 3.7 1.9 5.9l-7.9 32.399c-1.2 5.101 4.3 9.3 8.9 6.601l29.1-17.101c1.9-1.1 4.2-1.1 6.1 0l29.101 17.101c4.6 2.699 10.1-1.4 8.899-6.601l-7.8-32.399c-.5-2.2.2-4.4 1.9-5.9l26.3-23.1c3.8-3.5 1.6-10-3.6-10.5z'/%3e%3c/svg%3e");
}


.rating > .active-input:not(:checked) ~ label:hover,
.rating > .active-input:not(:checked) ~ label:hover ~ label {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='126.729' height='126.73'%3e%3cpath fill='%23d8b11e' d='M121.215 44.212l-34.899-3.3c-2.2-.2-4.101-1.6-5-3.7l-12.5-30.3c-2-5-9.101-5-11.101 0l-12.4 30.3c-.8 2.1-2.8 3.5-5 3.7l-34.9 3.3c-5.2.5-7.3 7-3.4 10.5l26.3 23.1c1.7 1.5 2.4 3.7 1.9 5.9l-7.9 32.399c-1.2 5.101 4.3 9.3 8.9 6.601l29.1-17.101c1.9-1.1 4.2-1.1 6.1 0l29.101 17.101c4.6 2.699 10.1-1.4 8.899-6.601l-7.8-32.399c-.5-2.2.2-4.4 1.9-5.9l26.3-23.1c3.8-3.5 1.6-10-3.6-10.5z'/%3e%3c/svg%3e");
}

.star-icon {
  color: yellow;
}
.feedback {
  border-radius: 8px;
  display: inline-block;
}

.touch-none {
  pointer-events: none;
}
</style>